import React from 'react';
import { Flex } from '@cleartax/zoids';
import { ToastNature } from '../../common/types';
import { TOAST_ERROR,TOAST_CHECK_MARK } from '../../constants/urls';
import { ToastText } from './styles';

interface ToastProps {
    description:string;
    nature: ToastNature;
}
let toastIcon: string | undefined;

const ToastContent = ({ description,nature }:ToastProps) =>{
  
  const getToastIcon=(toastnature:ToastNature )=>{
    switch(toastnature){
      case ToastNature.ERROR:
        toastIcon =TOAST_ERROR
        return toastIcon
      case ToastNature.WARNING:
        toastIcon =TOAST_CHECK_MARK
        return toastIcon
      case ToastNature.SUCCESS:
        toastIcon = TOAST_CHECK_MARK
        return toastIcon
    }
  }
  getToastIcon(nature);

  return (
      <Flex flexDirection="row" justifyContent="flex-start" alignItems="center">
        <img src={toastIcon} alt="" />
        <ToastText>{description}</ToastText>
      </Flex>
)
}

export default ToastContent;
